import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'
import OldPartnerApiSpec from 'specs/partner-api-v2-old.yaml'
import OldConvertedPartnerApiSpec from 'specs/partner-api-v2-old-converted.yaml'

import { asContainer } from 'lib/container'

import { LinkInline } from 'components/Buttons'
import { OpenApi } from 'components/OpenApi'

import { AlertBox } from './AlertBox'

type State = {}

export const container = asContainer<State>()({
	path: '/apis/partner-api/swagger',
	title: 'Partner API',
	authentication: { type: 'public' },
	Running: ({ statuspageApi }) => (
		<>
			<AlertBox>
				This is the old Swagger 2.0 version,{' '}
				<LinkInline type='link' name='Apis/PartnerApi/v2'>
					please use the OpenApi 3.1 version
				</LinkInline>
			</AlertBox>
			<OpenApi
				apiDocument={OldConvertedPartnerApiSpec as OpenApi3.Document}
				specToDownload={OldPartnerApiSpec as OpenApi3.Document}
				statuspageApi={statuspageApi}
			/>
		</>
	),
})
